import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useIncomingInvoicePaymentRuns() {
	/** Query */
	const query = useQuery({
		queryKey: ["incoming-invoices", "payment-runs"],
		queryFn: async () => {
			const response = await client.incoming_invoices["payment-runs"].$get();
			const data = await responseHandler(response);
			return data.paymentRuns;
		},
	});

	/** Return */
	return { ...query, paymentRuns: query.data ?? [] };
}
